import { SystemField } from "./system-field";

export class ReportSaleByChannel extends SystemField{
    sale_hour?:string; 
    total_pax?:number; 
    total_qty?:number;
    channel?:string;
    sub_amt?:number;
    discount_amt?:number;
    vat_amt?:number;
    total_amt?:number;
    total_cost?:number;
    sale_summary_id?:string;
}
